import { Icon } from '@equinor/eds-core-react'
import type { IconData } from '@equinor/eds-icons'
import { tokens } from '@equinor/eds-tokens'
import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

interface InfoBannerProps {
    icon: IconData
    children: ReactNode
    placement?: 'global' | 'inline'
}

export function InfoBanner({ icon, children, placement = 'inline' }: InfoBannerProps): ReactElement {
    return (
        <BannerSurface $placement={placement} role="status">
            <BannerIcon data={icon} size={24} />
            <BannerContent $placement={placement}>{children}</BannerContent>
        </BannerSurface>
    )
}

const infoText = 'var(--eds-color-text-banner-info, #045e8d)'

const BannerSurface = styled.div<{ $placement: 'global' | 'inline' }>`
    display: flex;
    align-items: ${({ $placement }) => ($placement === 'global' ? 'center' : 'flex-start')};
    gap: ${({ $placement }) => ($placement === 'global' ? '0' : tokens.spacings.comfortable.small)};
    background: var(--eds-color-surface-banner-info, ${tokens.colors.ui.background__info.rgba});
    color: ${infoText};
    padding: ${({ $placement }) =>
        $placement === 'global' ? tokens.spacings.comfortable.medium : tokens.spacings.comfortable.small};
    width: ${({ $placement }) => ($placement === 'global' ? '100%' : 'min(881px, 100%)')};
    box-sizing: border-box;

    ${({ $placement }) =>
        $placement === 'global'
            ? `
                position: sticky;
                left: 0;
                z-index: 10000;
            `
            : `
                margin-top: ${tokens.spacings.comfortable.medium};
            `}
`

const BannerIcon = styled(Icon)`
    flex: 0 0 auto;
    color: var(--eds-color-icon-banner-info, #045e8d);
`

const BannerContent = styled.div<{ $placement: 'global' | 'inline' }>`
    display: flex;
    flex-direction: column;
    min-width: 0;

    & > * {
        margin: 0;
    }

    ${({ $placement }) =>
        $placement === 'global' &&
        `
            & > * {
                margin: 4px 8px 0;
            }
        `}
`
